import { Avatar, SxProps, Theme } from '@mui/material';
import { RadioChecked, RadioUnchecked } from 'Images';

const RADIO_ICON_SIZE = '24px';

interface IRadioIconProps {
  sx?: SxProps<Theme>;
}

export const RadioUncheckedIcon = ({ sx }: IRadioIconProps) => (
  <Avatar
    alt=''
    src={RadioUnchecked}
    sx={{ width: RADIO_ICON_SIZE, height: RADIO_ICON_SIZE, ...sx }}
  />
);

export const RadioCheckedIcon = ({ sx }: IRadioIconProps) => (
  <Avatar
    alt=''
    src={RadioChecked}
    sx={{ width: RADIO_ICON_SIZE, height: RADIO_ICON_SIZE, ...sx }}
  />
);

export const radioIconProps = () => ({
  icon: <RadioUncheckedIcon />,
  checkedIcon: <RadioCheckedIcon />,
});
